import { Component } from '@angular/core';
import { App, NavController } from 'ionic-angular';
import { TasksDetailComponent } from '../../components/tasks-detail/tasks-detail';

@Component({
  selector: 'home',
  templateUrl: 'home.html'
})
export class HomePage {

  constructor(public app: App, public nav: NavController) { }

  ionViewDidLoad() {
    this.app.setTitle('Home');
  }

  addVoucher() {
    this.nav.push(TasksDetailComponent);
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts